// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".green-text[data-v-9d360b3e]{color:green}.red-text[data-v-9d360b3e]{color:red}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Settings/CertificateProviders/Form.vue"],"names":[],"mappings":"AACA,6BACI,WAAJ,CAEA,2BACI,SACJ","sourcesContent":["\n.green-text {\n    color: green;\n}\n.red-text {\n    color: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
